<template>
  <div id="com_knowledge">
    <div class="line">
      <div class="title"><span>*</span>可见部门</div>
      <div class="value">
        <el-cascader
          v-model="value.departmentIds"
          :options="value.departTreeData"
          :props="props"
          collapse-tags
          clearable
        ></el-cascader>
      </div>
    </div>
    <div class="line">
      <div class="title"><span>*</span>分组</div>
      <div class="value">
        <el-cascader
          v-model="value.categoryId"
          :props="props2"
          :options="value.categoryList"
          clearable
        ></el-cascader>
      </div>
    </div>
    <div class="line">
      <div class="title">标题</div>
      <div class="value">
        <el-input
          v-model="value.title"
          placeholder="输入标题,方便识别与检索"
          clearable
          :disabled="value.isDisable"
        ></el-input>
      </div>
    </div>
    <div class="line">
      <div class="title">摘要</div>
      <div class="value">
        <el-input
          type="textarea"
          :rows="3"
          v-model="value.content"
          placeholder="输入问题的摘要,进一步描述"
          maxlength="500"
          clearable
          show-word-limit
          :disabled="value.isDisable"
        ></el-input>
      </div>
    </div>

    <div class="line">
      <div class="title">内容</div>
      <div class="value">
        <myEditor :content="value.additional" @setHtml="setHtml"></myEditor>
      </div>
    </div>
    <div class="showImg" v-if="show" v-viewer="{ movable: false }">
      <div class="close" @click="show = false">X</div>
      <img :src="showImg" alt="" />
    </div>
  </div>
</template>

<script>
import myEditor from "@/components/myEditor.vue";
export default {
  components: {
    myEditor,
  },
  props: ["knowledgeData"],
  filters: {
    controlWord(value) {
      if (!value) return "";
      if (value.length > 8) {
        return value.slice(0, 8) + "...";
      }
      return value;
    },
  },
  data() {
    return {
      value: this.knowledgeData,
      documentImg1: require("@/assets/img/knowledge/word.png"),
      documentImg2: require("@/assets/img/knowledge/excel.png"),
      documentImg3: require("@/assets/img/knowledge/PDF.png"),
      show: false,
      showImg: "",
      props: { multiple: true, emitPath: false, value: "id" },
      props2: { emitPath: false, label: "name", value: "id" },
    };
  },
  watch: {
    knowledgeData() {
      //父组件值变化->>子组件也变化
      this.value = this.knowledgeData;
    },
    value(newvalue) {
      //上一步的子组件(data)变化 提交给父组件事件 进行页面数据的更新
      this.$emit("show", newvalue);
    },
  },
  methods: {
    setHtml(html) {
      console.log("html", html);
      this.value.additional = html;
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#com_knowledge {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  > .line {
    width: 100%;
    height: auto;
    min-height: 35px;
    display: flex;
    align-items: flex-start;
    margin-top: 10px;
    > .title {
      width: 14%;
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      padding-right: 8px;
      box-sizing: border-box;
      font-weight: bold;
      > span {
        color: red;
      }
    }
    > .value {
      width: 0;
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      > .upload_content {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        > .upload_content_value {
          width: 150px;
          height: 100px;
          border: 1px solid @boderColor;
          border-radius: 3px;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          align-items: center;
          margin: 5px;
          > .upload_content_value_title {
            width: 100%;
            height: 20px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            box-sizing: border-box;
            padding-left: 5px;
          }
          > .upload_content_value_data,
          > .upload_content_value_but {
            width: 92%;
            height: 0;
            flex: 1;
            box-sizing: border-box;
            // padding: 5px;
            margin: 5px;
            border: 1px solid #d1d3d862;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          > .upload_content_value_data {
            position: relative;
            > .upload_content_value_data_hover {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              opacity: 0;
              z-index: 10;
              transition: 0.3s;
              &:hover {
                opacity: 1;
                background-color: rgba(0, 0, 0, 0.281);
              }
              > i {
                margin: 0 10px;
                font-size: 30px;
                transition: 0.3s;
                &:hover {
                  cursor: pointer;
                  color: @tipColor;
                }
              }
            }
          }
          .upload_content_value_but-upload {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            color: rgba(68, 68, 68, 0.432);
            transition: 0.3s;
            font-size: 13px;
            > i {
              font-size: 30px;
            }
            &:hover {
              color: @activeColor;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  > .showImg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.144);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 15;
    > .close {
      width: auto;
      height: auto;
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      transition: 0.3s;
      font-size: 18px;
      &:hover {
        cursor: pointer;
        color: @closeColor;
      }
    }
  }
  /deep/ .el-cascader {
    width: 100%;
  }
}
</style>
